import axios from 'axios'

// API base URL must be explicitly set via environment variable
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

if (!API_BASE_URL) {
  console.error('VITE_API_BASE_URL is not set! Please check your .env file')
}

console.log('API_BASE_URL:', API_BASE_URL)
console.log('Environment:', import.meta.env.MODE)

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
})

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    // Auth token will be set by authService.setAuthToken()
    // This interceptor is kept for any additional request processing
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      
      // Try to refresh token first
      try {
        // Import here to avoid circular dependency
        const { useAuthStore } = await import('../stores/authStore')
        const { refreshToken, clearAuth } = useAuthStore.getState()
        
        if (originalRequest.url?.includes('/auth/refresh')) {
          // If refresh endpoint itself failed, clear auth
          clearAuth()
          window.location.href = '/app/login'
          return Promise.reject(error)
        }
        
        await refreshToken()
        
        // Retry original request with new token
        return apiClient(originalRequest)
      } catch (refreshError) {
        // Refresh failed, clear auth and redirect
        const { useAuthStore } = await import('../stores/authStore')
        const { clearAuth } = useAuthStore.getState()
        clearAuth()
        window.location.href = '/app/login'
        return Promise.reject(refreshError)
      }
    }
    
    return Promise.reject(error)
  }
)